export default __webpack_public_path__ + "static/media/Tutorial-Step-2.3.ac4372e8.jpg";